"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserGroupList = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
const component_1 = require("@front/layouts/default-layout/component");
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
  <div class="user-group-list-page">
    <crud-table title="${'route.user_group.list'.t()}" addText="${'route.user_group.create'.t()}" resource="user_group" searchPlaceholder="Search user groups..."
      indexEndpoint="user-group.index" listEndpoint="user-group.list" deleteEndpoint="user-group.delete"
      editRoute="/user-group/edit/:id" addRoute="/user-group/create" :columns="${x => x.tableColumns}">
    </crud-table>
  </div>
</div>
`;
const styles = null;
const shadowOptions = { "mode": "open" };
let UserGroupList = class UserGroupList extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.tableColumns = [
            { key: 'name', header: 'userGroup.name'.t() },
            { key: 'company', header: 'company.form.name.label'.t(), formatter: (company) => (company === null || company === void 0 ? void 0 : company.name) || '-' },
            { key: 'description', header: 'userGroup.description'.t(), formatter: (desc) => desc || '-' },
            {
                key: 'active',
                header: 'userGroup.active'.t(),
                formatter: (active) => active ?
                    '<span class="badge badge-success">Yes</span>' :
                    '<span class="badge badge-secondary">No</span>'
            }
        ];
    }
    connectedCallback() {
        if (component_1.DefaultLayout.USER.role === backendImport_1.UserRoles.SUPER_ADMIN) {
            this.tableColumns.push({
                key: 'owner_name', header: 'userGroup.owner'.t(),
                formatter: (owner) => owner || '-'
            });
        }
        super.connectedCallback();
    }
};
exports.UserGroupList = UserGroupList;
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], UserGroupList.prototype, "tableColumns", void 0);
exports.UserGroupList = UserGroupList = __decorate([
    (0, client_1.RWSView)('user-group-list', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], UserGroupList);
UserGroupList.defineComponent();
